import React, {useEffect, useRef, useState} from 'react';

import CardHeader from '../../components/common/card-header/CardHeader';
import {Card, FlexItem, FlexLayout, StackLayout, Text} from '@salt-ds/core';
import StepTracker from '../../components/common/StepTracker';
import Constants from '../../components/common/Constants';
import '../CommonCard.css';
import {useIntl} from 'react-intl';
import CardAlert from '../../components/common/card-alert/CardAlert';
import PageNavigation from '../../components/common/page-navigation/PageNavigation';
import {useLocation, useNavigate} from 'react-router';
import {customerServiceLink} from '../../common/ApiUtils';

function OnlineProfileRegistrationReceivePassword() {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const mainRef = useRef(null);

  useEffect(() => {
    document.title = intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.step3.page.title'});
    // Set focus to main element for screen reader announcement
    if (mainRef.current) {
      mainRef.current.focus();
    }
    const expectedPreviousPage = '/onlineProfileRegistrationCreateUserId';
    if (location.state?.from !== expectedPreviousPage) {
      navigate('/');
    }
  }, [intl,navigate,location]);
  const [hasError, setHasError] = useState(true);


  const [headerContent, setHeaderContent] = useState(<CardAlert status={"success"}
    setHasError={setHasError}>{Constants.onlineProfileRegistrationDefaultTempPasswordMessage(sessionStorage.getItem("userEmail"))}</CardAlert>);

  const handleSubmit = (event) => {
    event.preventDefault();
    //Submit the form
    navigate('/');
  };

  return (
    <main ref={mainRef} role="main" aria-label="Online Profile Registration Receive Password" tabIndex="-1">
      <FlexLayout className={"page-content"}>
        <FlexItem className={`error-wrapper ${hasError ? 'visible' : ''}`}>
          <div>
            {
              headerContent
            }
          </div>
        </FlexItem>

        <FlexItem>
          <Card className="card-wrapper">
            <FlexItem className="card-content">
              <form autoComplete="off" data-testid="receive-password-form" onSubmit={handleSubmit}>
                <StackLayout gap={3}>
                  <CardHeader heading={Constants.onlineProfileRegistrationTitle}
                    subheading={Constants.onlineProfileRegistrationStep3Title}
                    style={{maxWidth: "24.5rem"}} />

                  <StepTracker label1={intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.flow.step1'})} step1="completed"
                    label2={intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.flow.step2'})} step2="completed"
                    label3={intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.flow.step3'})} step3="completed" />
                  <FlexItem>
                    <Text>
                      {Constants.onlineProfileRegistrationStep3InstructionalText(customerServiceLink)}
                    </Text>
                  </FlexItem>
                </StackLayout>
                <PageNavigation style={{marginTop: "60%"}} isContinue={true} buttonText="RETURN TO LOG IN" />
              </form>
            </FlexItem>
          </Card>
        </FlexItem>
      </FlexLayout>
    </main>
  );
}

export default OnlineProfileRegistrationReceivePassword;